export default __webpack_public_path__ + "static/media/Ameta-logo-hvit-flat_1.44feeb1a.svg";